import api from 'apis/restaurant-api/api';

import {
  MenuSyncPayload,
  MerchantVenuesResponse,
  PullIntentsResponse,
  PushIntentsResponse,
  SearchMerchantVenuesResponse,
  SyncInfoResponse,
  SyncIntentState,
} from './types';

export const fetchPaginatedMerchantVenues = (merchantId: string, pageSize: number, pageToken: string | null) =>
  api
    .get<MerchantVenuesResponse>(`/v2/merchant-admin/merchants/${merchantId}/venues`, {
      params: {
        page_size: pageSize,
        page_token: pageToken,
      },
    })
    .then(response => response.data);

export const searchMerchantVenues = (merchantId: string, searchString: string) =>
  api
    .get<SearchMerchantVenuesResponse>(`/v2/merchant-admin/merchants/${merchantId}/venues/search`, {
      params: { q: searchString, page_size: 1000 },
    })
    .then(response => response.data);

export const startMenuSync = (menuId: string, payload: MenuSyncPayload) =>
  api.post(`/v2/merchant-admin/menus/${menuId}/pushes`, payload).then(response => response.data);

export const fetchMenuSyncInfo = (menuId: string) =>
  api.get<SyncInfoResponse>(`/v2/merchant-admin/menus/${menuId}/synchronizations`).then(response => response.data);

export const fetchMenuPushes = (
  menuId: string,
  pageToken: string | null,
  stateFilters: SyncIntentState[] | null,
  pageSize: number = 5,
): Promise<PushIntentsResponse> =>
  api
    .get<PushIntentsResponse>(`/v2/merchant-admin/menus/${menuId}/pushes`, {
      params: {
        page_size: pageSize,
        page_token: pageToken,
        states: stateFilters,
      },
    })
    .then(response => response.data);

export const fetchMenuPulls = (
  menuId: string,
  pageToken: string | null,
  stateFilters: SyncIntentState[] | null,
  pageSize: number = 5,
): Promise<PullIntentsResponse> =>
  api
    .get<PullIntentsResponse>(`/v2/merchant-admin/menus/${menuId}/pulls?page_size=${pageSize}`, {
      params: {
        page_size: pageSize,
        page_token: pageToken,
        states: stateFilters,
      },
    })
    .then(response => response.data);

export const revokePendingPushes = (menuId: string, intentIds: string[]) =>
  api.patch(`/v2/merchant-admin/menus/${menuId}/pushes`, {
    intent_ids: [...intentIds],
    state: 'revoked',
  });
